import { AddModal, FormLead } from "./styles.js";
import { TableBar } from '../../components/table/styles';
import { Autocomplete, Button, CircularProgress, Divider, InputAdornment, Stack, Switch, TextField } from "@mui/material";
import BasicTable from "../../components/table/index.jsx";
import SelectMui from "../../components/select/index.jsx";
import { ModalAlert } from "../../components/modal/index.jsx";
import { ModalAlertDiv } from "../reports/style.js";
import { useState } from "react";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useEffect } from "react";
import { api } from "../../services/axios.js";
import AddIcon from '@mui/icons-material/Add';
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "90%",
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',

  }
};

export default function ApiPage() {
  const url = "core/ajax/userapi";

  const headers = [
    { label: 'Id', value: 'id' },
    { label: 'Name', value: 'name' },
    { label: 'Token', value: 'hash' },
    { label: 'Created Date', value: 'created_on' },
    { label: 'Active', value: 'active' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [showModal, setShowModal] = useState(false)
  const [rows, setRows] = useState({ default: [], filter: [] })
  const [error, setError] = useState(defaultError)
  const [form, setForm] = useState(defaultForm);
  const [isCreate, setIsCreate] = useState(true);

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [id, setId] = useState();


  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              id: Number(e.id),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              id: Number(e.id),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  const createUser = () => {
      api.post(url, {
        type: 'insert',
        authx: '',

        name: form.name,
        status: form.active ? '1' : '0'
      })
        .then(function (res) {
          setAlert(res.data)
          listUpdate()
        })
        .catch(function (error) {
          console.log(error);
        });
  }


  const updateForm = (row) => {
      api.post(url, {
        type: 'info',
        id: row.id.toString(),
        authx: ''
      })
        .then(function (res) {
          setForm({
            name: res.data['0'].name,
            active: res.data['0'].active === '1' ? true : false
          })
        })
        .catch(function (error) {
          console.log(error);
        });
    setIsCreate(false)
    setShowModal(true)
    setId(row.id.toString())
  }

  const confirmUpdateForm = () => {
      api.post(url, {
        type: 'update',
        authx: '',
        id: id,

        name: form.name,
        active: form.active ? '1' : '0'
      }).then(function (res) {
        setAlert(res.data)
        listUpdate()
      }).catch(function (error) {
        console.log(error);
      });
  }

  const validation = () => {
    if (form.name === '') {
      return false
    } else {
      return true
    }
  }


  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.id.toString().includes(e.target.value) ||
        row.hash.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.created_on.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>API Users</h1>
      <div className='buttons'>
        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button startIcon={<AddIcon />} onClick={() => {
          setShowModal(!showModal)
          setIsCreate(true)
        }} variant="contained">Add</Button>
      </div>
      <BasicTable type={'api'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} handleActive={{}} />
      <Modal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setError(defaultError)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <Stack
            direction="row"
            spacing={2}
            sx={{ marginBottom: '1rem' }}
            justifyContent="space-between">
            <h1>User</h1>
            <Switch checked={form.active} onChange={(e) => { setForm({ ...form, active: e.target.checked }) }} />

          </Stack>
          <Divider className='divider' variant="middle" />
          <Stack sx={{ gap: '.8rem' }}>
            <TextField label="Name" variant="outlined"
              helperText={error.name ? "Incorrect entry." : ""}
              error={error.name}
              value={form.name}
              onChange={(e) => {
                e.target.value !== '' ? setError({ ...error, name: false }) : setError({ ...error, name: true })
                setForm({
                  ...form,
                  name: e.target.value
                })
              }} />
            <Button onClick={() => {
              if (validation()) {
                isCreate ? createUser() : confirmUpdateForm()
                setShowAlert(!showAlert)
              } else {
                console.log(form);
              }
            }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>
          </Stack>
        </AddModal>
      </Modal>

      <ModalAlert showModal={showAlert} onClose={() => setShowAlert(!showAlert)} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Updating Engines</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h2>Error code {alert.code}</h2>
              <h3>:&#40;	</h3>
              <p>{alert.msg}</p>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>}
      </ModalAlert>
    </TableBar >
  );
}

const defaultForm = {
  name: '',
  active: 0
}

const defaultError = {
  company: false,
  adress: false,
  city: false,
  country: false,
  language: false,
}